import { render, staticRenderFns } from "./auditNew.vue?vue&type=template&id=62fff34c&scoped=true"
import script from "./auditNew.vue?vue&type=script&lang=js"
export * from "./auditNew.vue?vue&type=script&lang=js"
import style0 from "./auditNew.vue?vue&type=style&index=0&id=62fff34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fff34c",
  null
  
)

export default component.exports